var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyOngoing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 222.255,
    height: 209.85,
    viewBox: "0 0 222.255 209.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration_",
    "data-name": "Illustration ",
    transform: "translate(-25.046 -57.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-9",
    transform: "translate(28.083 266.779)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509674",
    "data-name": "Path 509674",
    d: "M250.329,475.87c0,.075-49.074.13-109.6.13s-109.614-.055-109.614-.13,49.074-.13,109.614-.13S250.329,475.785,250.329,475.87Z",
    transform: "translate(-31.11 -475.74)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-3--inject-9",
    transform: "translate(144.198 163.863)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203974",
    "data-name": "Rectangle 203974",
    width: 48.453,
    height: 31.953,
    rx: 5.89,
    transform: "translate(0.129 0.257)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509675",
    "data-name": "Path 509675",
    d: "M308.63,302.432a2.69,2.69,0,0,0,.4-.045,2.794,2.794,0,0,0,1.092-.4,2.975,2.975,0,0,0,1.207-1.422,7.419,7.419,0,0,0,.2-2.579c0-3.946-.025-9.649-.045-16.69v-6.965a8.325,8.325,0,0,0-.06-1.462,2.839,2.839,0,0,0-1.858-2.108,4.081,4.081,0,0,0-1.5-.16H266.076a2.824,2.824,0,0,0-2.759,2.228,4.655,4.655,0,0,0-.065.961v25.313a3.225,3.225,0,0,0,.3,1.637,2.829,2.829,0,0,0,1.107,1.182,2.869,2.869,0,0,0,1.557.386h19.609l16.69.04,4.537.025h-4.537l-16.69.04H266.206a3.165,3.165,0,0,1-1.678-.416,3.089,3.089,0,0,1-1.2-1.282,3.505,3.505,0,0,1-.326-1.743V273.663a4.7,4.7,0,0,1,.07-1,3.09,3.09,0,0,1,3-2.434h41.988a4.366,4.366,0,0,1,1.582.175,3.055,3.055,0,0,1,2,2.273,8.509,8.509,0,0,1,.06,1.5v6.965c0,7.041-.03,12.744-.04,16.69v1.4a3.13,3.13,0,0,1-.225,1.212,3,3,0,0,1-1.252,1.437,2.7,2.7,0,0,1-1.117.376A2.406,2.406,0,0,1,308.63,302.432Z",
    transform: "translate(-262.992 -270.217)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203975",
    "data-name": "Rectangle 203975",
    width: 1.858,
    height: 7.401,
    transform: "translate(21.847 18.815)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203976",
    "data-name": "Rectangle 203976",
    width: 1.858,
    height: 8.473,
    transform: "translate(6.318 17.743)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203977",
    "data-name": "Rectangle 203977",
    width: 1.858,
    height: 10.235,
    transform: "translate(10.199 15.976)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203978",
    "data-name": "Rectangle 203978",
    width: 1.858,
    height: 9.675,
    transform: "translate(14.08 16.536)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203979",
    "data-name": "Rectangle 203979",
    width: 1.858,
    height: 12.949,
    transform: "translate(17.966 13.262)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203980",
    "data-name": "Rectangle 203980",
    width: 1.858,
    height: 12.884,
    transform: "translate(25.727 13.327)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203981",
    "data-name": "Rectangle 203981",
    width: 1.858,
    height: 8.653,
    transform: "translate(29.613 17.558)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203982",
    "data-name": "Rectangle 203982",
    width: 1.858,
    height: 12.318,
    transform: "translate(33.494 13.892)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203983",
    "data-name": "Rectangle 203983",
    width: 1.858,
    height: 15.093,
    transform: "translate(37.375 11.118)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203984",
    "data-name": "Rectangle 203984",
    width: 1.858,
    height: 12.384,
    transform: "translate(41.261 13.832)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509676",
    "data-name": "Path 509676",
    d: "M273.584,278.352a1.172,1.172,0,1,1-1.172-1.172A1.172,1.172,0,0,1,273.584,278.352Z",
    transform: "translate(-267.11 -273.693)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509677",
    "data-name": "Path 509677",
    d: "M279.663,278.352a1.167,1.167,0,1,1-.34-.828,1.172,1.172,0,0,1,.34.828Z",
    transform: "translate(-270.145 -273.693)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509678",
    "data-name": "Path 509678",
    d: "M285.664,278.352a1.172,1.172,0,1,1-1.172-1.172A1.172,1.172,0,0,1,285.664,278.352Z",
    transform: "translate(-273.141 -273.693)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-2--inject-9",
    transform: "translate(202.792 95.016)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203985",
    "data-name": "Rectangle 203985",
    width: 41.322,
    height: 64.537,
    rx: 8.43,
    transform: "translate(0.078 0.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509679",
    "data-name": "Path 509679",
    d: "M417.183,197.411h.135a1.831,1.831,0,0,0,.391-.035,4.362,4.362,0,0,0,1.457-.476,4.291,4.291,0,0,0,1.723-1.763,4.206,4.206,0,0,0,.451-1.5c.04-.566,0-1.182,0-1.828,0-5.178-.025-12.664-.045-21.908s0-20.265-.025-32.494a4.141,4.141,0,0,0-2-3.8c-1.322-.851-3-.5-4.577-.581H384.3a4.1,4.1,0,0,0-3.876,2.784,7.8,7.8,0,0,0-.215,2.544v53.3c0,.651-.025,1.317,0,1.938a4.126,4.126,0,0,0,3.505,3.691,15.02,15.02,0,0,0,1.778.05h1.758l21.908.045,5.954.025h0l-5.954.025-21.908.04H385.51a16.849,16.849,0,0,1-1.8-.05,4.316,4.316,0,0,1-3.686-3.861c-.04-.661,0-1.3,0-1.958V137.016a4.39,4.39,0,0,1,.23-1.322,4.317,4.317,0,0,1,1.577-2.138,4.372,4.372,0,0,1,2.544-.826h32.784a4.377,4.377,0,0,1,3.946,2.344,4.645,4.645,0,0,1,.4,1.117,5.807,5.807,0,0,1,.09,1.172c0,12.228,0,23.24-.03,32.494s-.03,16.73-.04,21.908c0,.646,0,1.252-.03,1.833a4.146,4.146,0,0,1-.466,1.547,4.347,4.347,0,0,1-1.768,1.768,4.116,4.116,0,0,1-1.5.456A3.766,3.766,0,0,1,417.183,197.411Z",
    transform: "translate(-380.004 -132.729)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16795",
    "data-name": "Ellipse 16795",
    cx: 1.267,
    cy: 1.267,
    r: 1.267,
    transform: "translate(4.379 4.412)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509680",
    "data-name": "Path 509680",
    d: "M397.814,142.807a1.267,1.267,0,1,1-1.267-1.267A1.267,1.267,0,0,1,397.814,142.807Z",
    transform: "translate(-387.631 -137.128)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16796",
    "data-name": "Ellipse 16796",
    cx: 1.267,
    cy: 1.267,
    r: 1.267,
    transform: "translate(10.919 4.412)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509681",
    "data-name": "Path 509681",
    d: "M421.459,157.22c0,.07-6.545.13-14.617.13s-14.622-.06-14.622-.13,6.545-.13,14.622-.13S421.459,157.145,421.459,157.22Z",
    transform: "translate(-386.103 -144.891)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509682",
    "data-name": "Path 509682",
    d: "M421.459,162.36c0,.07-6.545.13-14.617.13s-14.622-.06-14.622-.13,6.545-.13,14.622-.13S421.459,162.285,421.459,162.36Z",
    transform: "translate(-386.103 -147.457)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509683",
    "data-name": "Path 509683",
    d: "M421.459,167.5c0,.07-6.545.13-14.617.13s-14.622-.06-14.622-.13,6.545-.13,14.622-.13S421.459,167.425,421.459,167.5Z",
    transform: "translate(-386.103 -150.023)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509684",
    "data-name": "Path 509684",
    d: "M421.459,172.635c0,.07-6.545.13-14.617.13s-14.622-.06-14.622-.13,6.545-.135,14.622-.135S421.459,172.56,421.459,172.635Z",
    transform: "translate(-386.103 -152.585)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509685",
    "data-name": "Path 509685",
    d: "M421.459,177.77c0,.075-6.545.13-14.617.13s-14.622-.055-14.622-.13,6.545-.13,14.622-.13S421.459,177.7,421.459,177.77Z",
    transform: "translate(-386.103 -155.151)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509686",
    "data-name": "Path 509686",
    d: "M421.459,182.87c0,.075-6.545.13-14.617.13s-14.622-.055-14.622-.13,6.545-.13,14.622-.13S421.459,182.82,421.459,182.87Z",
    transform: "translate(-386.103 -157.697)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509687",
    "data-name": "Path 509687",
    d: "M421.459,222.24c0,.07-6.545.13-14.617.13s-14.622-.06-14.622-.13,6.545-.13,14.622-.13S421.459,222.165,421.459,222.24Z",
    transform: "translate(-386.103 -177.352)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509688",
    "data-name": "Path 509688",
    d: "M421.459,227.87c0,.07-6.545.13-14.617.13s-14.622-.06-14.622-.13,6.545-.13,14.622-.13S421.459,227.78,421.459,227.87Z",
    transform: "translate(-386.103 -180.163)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509689",
    "data-name": "Path 509689",
    d: "M421.459,233.43c0,.07-6.545.13-14.617.13s-14.622-.06-14.622-.13,6.545-.13,14.622-.13S421.459,233.355,421.459,233.43Z",
    transform: "translate(-386.103 -182.939)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509690",
    "data-name": "Path 509690",
    d: "M421.459,239.02c0,.07-6.545.13-14.617.13s-14.622-.06-14.622-.13,6.545-.13,14.622-.13S421.459,238.945,421.459,239.02Z",
    transform: "translate(-386.103 -185.73)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509691",
    "data-name": "Path 509691",
    d: "M421.459,244.61c0,.075-6.545.135-14.617.135s-14.622-.06-14.622-.135,6.545-.13,14.622-.13S421.459,244.54,421.459,244.61Z",
    transform: "translate(-386.103 -188.521)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509692",
    "data-name": "Path 509692",
    d: "M422.23,190.33H392.29l.05-.035v10.566l-.05-.04h-.05V190.18h29.99Z",
    transform: "translate(-386.113 -161.411)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509693",
    "data-name": "Path 509693",
    d: "M422.28,193.96s-6.705.04-14.972.04-14.967,0-14.967-.04,6.7-.04,14.967-.04S422.28,193.96,422.28,193.96Z",
    transform: "translate(-386.163 -163.278)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509694",
    "data-name": "Path 509694",
    d: "M422.28,196.9s-6.705.035-14.972.035-14.967,0-14.967-.035,6.7-.04,14.967-.04S422.28,196.875,422.28,196.9Z",
    transform: "translate(-386.163 -164.746)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509695",
    "data-name": "Path 509695",
    d: "M422.28,199.8s-6.705.04-14.972.04-14.967,0-14.967-.04,6.7-.035,14.967-.035S422.28,199.785,422.28,199.8Z",
    transform: "translate(-386.163 -166.199)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509696",
    "data-name": "Path 509696",
    d: "M422.28,202.71s-6.705.035-14.972.035-14.967,0-14.967-.035,6.7-.04,14.967-.04S422.28,202.69,422.28,202.71Z",
    transform: "translate(-386.163 -167.647)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509697",
    "data-name": "Path 509697",
    d: "M422.28,205.615s-6.705.04-14.972.04-14.967,0-14.967-.04,6.7-.035,14.967-.035S422.28,205.595,422.28,205.615Z",
    transform: "translate(-386.163 -169.1)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509698",
    "data-name": "Path 509698",
    d: "M392.34,208.52s6.7-.04,14.967-.04,14.972,0,14.972.04-6.705.04-14.972.04S392.34,208.54,392.34,208.52Z",
    transform: "translate(-386.163 -170.548)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509699",
    "data-name": "Path 509699",
    d: "M400.775,201.206s-.035-2.4-.035-5.363,0-5.363.035-5.363.04,2.4.04,5.363S400.8,201.206,400.775,201.206Z",
    transform: "translate(-390.357 -161.561)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509700",
    "data-name": "Path 509700",
    d: "M409.385,201.206s-.035-2.4-.035-5.363,0-5.363.035-5.363.04,2.4.04,5.363S409.41,201.206,409.385,201.206Z",
    transform: "translate(-394.655 -161.561)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509701",
    "data-name": "Path 509701",
    d: "M417.96,201.206c-.025,0-.04-2.4-.04-5.363s0-5.363.04-5.363.035,2.4.035,5.363S418,201.206,417.96,201.206Z",
    transform: "translate(-398.934 -161.561)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509702",
    "data-name": "Path 509702",
    d: "M426.61,201.206s-.04-2.4-.04-5.363,0-5.363.04-5.363.035,2.4.035,5.363S426.63,201.206,426.61,201.206Z",
    transform: "translate(-403.252 -161.561)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509703",
    "data-name": "Path 509703",
    d: "M435.22,201.206c-.025,0-.04-2.4-.04-5.363s0-5.363.04-5.363.035,2.4.035,5.363S435.24,201.206,435.22,201.206Z",
    transform: "translate(-407.551 -161.561)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509704",
    "data-name": "Path 509704",
    d: "M443.55,201.206s-.04-2.4-.04-5.363,0-5.363.04-5.363.04,2.4.04,5.363S443.57,201.206,443.55,201.206Z",
    transform: "translate(-411.71 -161.561)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509705",
    "data-name": "Path 509705",
    d: "M452.165,201.206s-.035-2.4-.035-5.363,0-5.363.035-5.363.04,2.4.04,5.363S452.185,201.206,452.165,201.206Z",
    transform: "translate(-416.013 -161.561)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509706",
    "data-name": "Path 509706",
    d: "M400.744,208.31a.323.323,0,1,1-.265-.24.26.26,0,0,1,.265.24Z",
    transform: "translate(-390.061 -170.338)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16797",
    "data-name": "Ellipse 16797",
    cx: 0.26,
    cy: 0.26,
    r: 0.26,
    transform: "translate(14.469 34.803)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509707",
    "data-name": "Path 509707",
    d: "M418.033,205.372a.265.265,0,1,1-.263-.229A.265.265,0,0,1,418.033,205.372Z",
    transform: "translate(-398.727 -168.881)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509708",
    "data-name": "Path 509708",
    d: "M426.656,199.4a.273.273,0,0,1-.386.386h0a.273.273,0,1,1,.386-.386Z",
    transform: "translate(-403.063 -165.975)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509709",
    "data-name": "Path 509709",
    d: "M435.366,199.4a.273.273,0,0,1-.386.386h0a.273.273,0,1,1,.386-.386Z",
    transform: "translate(-407.411 -165.975)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509710",
    "data-name": "Path 509710",
    d: "M443.54,205.112a.271.271,0,1,1-.381.386h0a.271.271,0,0,1,.381-.386Z",
    transform: "translate(-411.494 -168.827)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509711",
    "data-name": "Path 509711",
    d: "M409.473,196.639a.265.265,0,1,1-.12-.26A.265.265,0,0,1,409.473,196.639Z",
    transform: "translate(-394.453 -164.485)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509712",
    "data-name": "Path 509712",
    d: "M400.816,205.39a.265.265,0,0,1-.265.265.264.264,0,1,1,.265-.265Z",
    transform: "translate(-390.132 -168.875)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509713",
    "data-name": "Path 509713",
    d: "M443.538,208.1a.271.271,0,1,1-.383,0A.271.271,0,0,1,443.538,208.1Z",
    transform: "translate(-411.492 -170.317)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509714",
    "data-name": "Path 509714",
    d: "M435.256,202.485a.263.263,0,0,1-.526,0,.265.265,0,0,1,.265-.265.26.26,0,0,1,.26.265Z",
    transform: "translate(-407.326 -167.422)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509715",
    "data-name": "Path 509715",
    d: "M426.736,202.41a.265.265,0,0,1-.265.265.264.264,0,1,1,.265-.265Z",
    transform: "translate(-403.072 -167.387)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509716",
    "data-name": "Path 509716",
    d: "M396.391,213.96a2.178,2.178,0,0,1-.831,0A2.179,2.179,0,0,1,396.391,213.96Z",
    transform: "translate(-387.771 -173.263)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509717",
    "data-name": "Path 509717",
    d: "M405.171,213.96a2.178,2.178,0,0,1-.831,0A2.179,2.179,0,0,1,405.171,213.96Z",
    transform: "translate(-392.154 -173.263)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509718",
    "data-name": "Path 509718",
    d: "M413.991,213.96a2.178,2.178,0,0,1-.831,0A2.179,2.179,0,0,1,413.991,213.96Z",
    transform: "translate(-396.557 -173.263)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509719",
    "data-name": "Path 509719",
    d: "M422.791,213.96a2.178,2.178,0,0,1-.831,0,2.179,2.179,0,0,1,.831,0Z",
    transform: "translate(-400.951 -173.263)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509720",
    "data-name": "Path 509720",
    d: "M431.591,213.96a2.178,2.178,0,0,1-.831,0A2.179,2.179,0,0,1,431.591,213.96Z",
    transform: "translate(-405.344 -173.263)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509721",
    "data-name": "Path 509721",
    d: "M439.461,213.96a2.179,2.179,0,0,1-.831,0,2.178,2.178,0,0,1,.831,0Z",
    transform: "translate(-409.273 -173.263)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509722",
    "data-name": "Path 509722",
    d: "M447.331,213.96a2.178,2.178,0,0,1-.831,0A2.179,2.179,0,0,1,447.331,213.96Z",
    transform: "translate(-413.202 -173.263)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509723",
    "data-name": "Path 509723",
    d: "M390.431,211.42a1.623,1.623,0,0,1-.671,0A1.427,1.427,0,0,1,390.431,211.42Z",
    transform: "translate(-384.875 -171.995)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509724",
    "data-name": "Path 509724",
    d: "M390.431,208.04a1.623,1.623,0,0,1-.671,0A1.427,1.427,0,0,1,390.431,208.04Z",
    transform: "translate(-384.875 -170.308)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509725",
    "data-name": "Path 509725",
    d: "M390.431,204.66a1.623,1.623,0,0,1-.671,0,1.427,1.427,0,0,1,.671,0Z",
    transform: "translate(-384.875 -168.62)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509726",
    "data-name": "Path 509726",
    d: "M390.431,201.28a1.623,1.623,0,0,1-.671,0A1.427,1.427,0,0,1,390.431,201.28Z",
    transform: "translate(-384.875 -166.933)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509727",
    "data-name": "Path 509727",
    d: "M390.431,197.9a1.622,1.622,0,0,1-.671,0,1.427,1.427,0,0,1,.671,0Z",
    transform: "translate(-384.875 -165.246)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509728",
    "data-name": "Path 509728",
    d: "M390.431,194.52a1.622,1.622,0,0,1-.671,0A1.427,1.427,0,0,1,390.431,194.52Z",
    transform: "translate(-384.875 -163.558)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509729",
    "data-name": "Path 509729",
    d: "M390.431,191.14a1.623,1.623,0,0,1-.671,0A1.427,1.427,0,0,1,390.431,191.14Z",
    transform: "translate(-384.875 -161.871)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509730",
    "data-name": "Path 509730",
    d: "M392.235,205.714l-.045-.135,4.286-1.507,4.331-2.924,4.311,1.427,4.346-2.864,4.352-.01.02.01,4.131,2.924,4.006-2.649.08.12-4.086,2.7-.045-.03-4.151-2.934-4.261.01-4.367,2.879-4.311-1.427-4.3,2.9Z",
    transform: "translate(-386.088 -166.164)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509731",
    "data-name": "Path 509731",
    d: "M418.069,201.191l-4.221-2.869H409.5l-4.352-2.869-4.221-.04-4.311,4.367H392.34v-.145h4.211l4.316-4.367,4.321.04,4.352,2.869h4.352l4.126,2.809,4.121-7.246.125.07Z",
    transform: "translate(-386.163 -163.189)",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-1--inject-9",
    transform: "translate(71.462 57.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509732",
    "data-name": "Path 509732",
    d: "M136.011,57.45H241.584a4.387,4.387,0,0,1,4.387,4.387v86.024a6.3,6.3,0,0,1-6.3,6.3H138.379a6.3,6.3,0,0,1-6.3-6.3V61.381a3.931,3.931,0,0,1,3.931-3.931Z",
    transform: "translate(-124.898 -57.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509733",
    "data-name": "Path 509733",
    d: "M135.18,57.45H242.255a3.555,3.555,0,0,1,3.555,3.555v8.087H132.08V60.55a3.1,3.1,0,0,1,3.1-3.1Z",
    transform: "translate(-124.898 -57.32)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509734",
    "data-name": "Path 509734",
    d: "M245.97,80.57c0,.07-25.423.13-56.78.13s-56.79-.06-56.79-.13,25.418-.13,56.79-.13S245.97,80.5,245.97,80.57Z",
    transform: "translate(-125.058 -68.798)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509735",
    "data-name": "Path 509735",
    d: "M142.343,68.507a1.072,1.072,0,1,1-.314-.763A1.077,1.077,0,0,1,142.343,68.507Z",
    transform: "translate(-128.947 -62.302)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509736",
    "data-name": "Path 509736",
    d: "M149.183,68.507a1.072,1.072,0,1,1-.312-.761A1.077,1.077,0,0,1,149.183,68.507Z",
    transform: "translate(-132.362 -62.302)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509737",
    "data-name": "Path 509737",
    d: "M156.163,68.507a1.072,1.072,0,1,1-.314-.763A1.077,1.077,0,0,1,156.163,68.507Z",
    transform: "translate(-135.847 -62.302)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509738",
    "data-name": "Path 509738",
    d: "M246.925,97.87c0,.07-8.212.13-18.342.13s-18.342-.06-18.342-.13,8.212-.13,18.342-.13S246.925,97.815,246.925,97.87Z",
    transform: "translate(-163.92 -77.435)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509739",
    "data-name": "Path 509739",
    d: "M205.786,113.35c0,.075-9.83.13-21.948.13s-21.948-.055-21.948-.13,9.825-.13,21.948-.13S205.786,113.28,205.786,113.35Z",
    transform: "translate(-139.781 -85.163)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509740",
    "data-name": "Path 509740",
    d: "M205.786,121.64c0,.075-9.83.13-21.948.13s-21.948-.055-21.948-.13,9.825-.13,21.948-.13S205.786,121.57,205.786,121.64Z",
    transform: "translate(-139.781 -89.302)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509741",
    "data-name": "Path 509741",
    d: "M205.786,129.93c0,.075-9.83.135-21.948.135s-21.948-.06-21.948-.135,9.825-.13,21.948-.13S205.786,129.86,205.786,129.93Z",
    transform: "translate(-139.781 -93.44)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509742",
    "data-name": "Path 509742",
    d: "M205.786,138.225c0,.07-9.83.13-21.948.13s-21.948-.06-21.948-.13,9.825-.135,21.948-.135S205.786,138.15,205.786,138.225Z",
    transform: "translate(-139.781 -97.579)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509743",
    "data-name": "Path 509743",
    d: "M205.786,146.515c0,.07-9.83.13-21.948.13s-21.948-.06-21.948-.13,9.825-.135,21.948-.135S205.786,146.44,205.786,146.515Z",
    transform: "translate(-139.781 -101.718)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509744",
    "data-name": "Path 509744",
    d: "M205.786,169.55c0,.075-9.83.13-21.948.13s-21.948-.055-21.948-.13,9.825-.13,21.948-.13S205.786,169.48,205.786,169.55Z",
    transform: "translate(-139.781 -113.221)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509745",
    "data-name": "Path 509745",
    d: "M205.786,161.2c0,.075-9.83.13-21.948.13s-21.948-.055-21.948-.13,9.825-.13,21.948-.13S205.786,161.13,205.786,161.2Z",
    transform: "translate(-139.781 -109.052)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509746",
    "data-name": "Path 509746",
    d: "M293.8,111.79a11.858,11.858,0,1,0,11.853,11.854A11.858,11.858,0,0,0,293.8,111.79Zm.18,18.958a7.278,7.278,0,1,1,.005,0Z",
    transform: "translate(-199.716 -84.449)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509747",
    "data-name": "Path 509747",
    d: "M286.727,124.386a7.281,7.281,0,0,1,4.316-6.65l-1.823-4.1A11.863,11.863,0,0,0,282,124.566q0,.245,0,.5h4.772A5.182,5.182,0,0,1,286.727,124.386Z",
    transform: "translate(-199.746 -85.373)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509748",
    "data-name": "Path 509748",
    d: "M305.659,165c0,.06-4.392.11-9.81.11s-9.81-.05-9.81-.11,4.392-.115,9.81-.115S305.659,164.94,305.659,165Z",
    transform: "translate(-201.763 -110.954)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509749",
    "data-name": "Path 509749",
    d: "M305.641,168.6c0,.06-2.434.11-5.438.11s-5.443-.05-5.443-.11,2.439-.115,5.443-.115S305.641,168.53,305.641,168.6Z",
    transform: "translate(-206.116 -112.751)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509750",
    "data-name": "Path 509750",
    d: "M301.663,132v.5l-.961,2.248h-.841l.921-2.118h-.721v.421H299.4V132Z",
    transform: "translate(-208.433 -94.539)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509751",
    "data-name": "Path 509751",
    d: "M306.328,133.893c0,.5-.366.931-1.192.931a2.058,2.058,0,0,1-1.057-.265l.275-.586a1.382,1.382,0,0,0,.756.23c.265,0,.441-.105.441-.29s-.115-.275-.531-.275h-.741l.135-1.6h1.738v.6h-1.112l-.035.4h.18C306.013,133.021,306.328,133.407,306.328,133.893Z",
    transform: "translate(-210.769 -94.559)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509752",
    "data-name": "Path 509752",
    d: "M308.836,132.761a.7.7,0,1,1,.7.756.686.686,0,0,1-.7-.756Zm2.313-.721h.561l-1.868,2.729h-.561Zm-1.387.721c0-.275-.1-.386-.23-.386s-.23.11-.23.386.105.386.23.386S309.763,133.021,309.763,132.761Zm1,1.287a.7.7,0,1,1,.7.756.686.686,0,0,1-.7-.756Zm.926,0c0-.275-.1-.386-.23-.386s-.23.11-.23.386.1.386.23.386S311.691,134.328,311.691,134.048Z",
    transform: "translate(-213.142 -94.559)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203986",
    "data-name": "Rectangle 203986",
    width: 3.385,
    height: 7.797,
    transform: "translate(26.831 80.34)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203987",
    "data-name": "Rectangle 203987",
    width: 3.385,
    height: 7.797,
    transform: "translate(38.313 80.34)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203988",
    "data-name": "Rectangle 203988",
    width: 3.385,
    height: 14.897,
    transform: "translate(32.575 73.24)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203989",
    "data-name": "Rectangle 203989",
    width: 3.385,
    height: 14.897,
    transform: "translate(44.057 73.24)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203990",
    "data-name": "Rectangle 203990",
    width: 3.385,
    height: 14.472,
    transform: "translate(49.796 73.665)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203991",
    "data-name": "Rectangle 203991",
    width: 3.385,
    height: 14.472,
    transform: "translate(61.278 73.665)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203992",
    "data-name": "Rectangle 203992",
    width: 3.385,
    height: 14.472,
    transform: "translate(72.76 73.665)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203993",
    "data-name": "Rectangle 203993",
    width: 3.385,
    height: 22.068,
    transform: "translate(55.539 66.074)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203994",
    "data-name": "Rectangle 203994",
    width: 3.385,
    height: 19.905,
    transform: "translate(67.021 68.232)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203995",
    "data-name": "Rectangle 203995",
    width: 3.385,
    height: 14.472,
    transform: "translate(89.72 73.665)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203996",
    "data-name": "Rectangle 203996",
    width: 3.385,
    height: 11.693,
    transform: "translate(83.982 76.445)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203997",
    "data-name": "Rectangle 203997",
    width: 3.385,
    height: 22.193,
    transform: "translate(101.728 65.944)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203998",
    "data-name": "Rectangle 203998",
    width: 3.385,
    height: 11.693,
    transform: "translate(95.99 76.445)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203999",
    "data-name": "Rectangle 203999",
    width: 3.385,
    height: 11.693,
    transform: "translate(107.477 76.445)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204000",
    "data-name": "Rectangle 204000",
    width: 3.385,
    height: 16.855,
    transform: "translate(78.504 71.282)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16798",
    "data-name": "Ellipse 16798",
    cx: 0.871,
    cy: 0.871,
    r: 0.871,
    transform: "translate(56.08 65.203)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509753",
    "data-name": "Path 509753",
    d: "M229.892,189.135a1.582,1.582,0,1,1,1.582-1.577A1.582,1.582,0,0,1,229.892,189.135Zm0-3.035a1.457,1.457,0,1,0,1.452,1.457,1.457,1.457,0,0,0-1.452-1.457Z",
    transform: "translate(-172.941 -121.483)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509754",
    "data-name": "Path 509754",
    d: "M231.647,182.029l-.045-1.713.426.01-.8-.976-.8.981.441.005.045,1.693Z",
    transform: "translate(-173.999 -118.178)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509755",
    "data-name": "Path 509755",
    d: "M174.883,209.641a.871.871,0,1,1-.871-.871A.871.871,0,0,1,174.883,209.641Z",
    transform: "translate(-145.397 -132.866)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509756",
    "data-name": "Path 509756",
    d: "M173.3,210.575a1.577,1.577,0,1,1,1.119-.46A1.582,1.582,0,0,1,173.3,210.575Zm0-3.035a1.452,1.452,0,1,0,1.032.425,1.457,1.457,0,0,0-1.032-.425Z",
    transform: "translate(-144.688 -132.187)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509757",
    "data-name": "Path 509757",
    d: "M173.441,199.73l.045,1.783-.446-.005.831,1.012.831-1.022-.461-.005-.045-1.758Z",
    transform: "translate(-145.348 -128.353)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509758",
    "data-name": "Path 509758",
    d: "M265.411,192.29l.045,1.783-.446-.005.831,1.012.831-1.022-.461-.005-.045-1.758Z",
    transform: "translate(-191.263 -124.639)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509759",
    "data-name": "Path 509759",
    d: "M223.525,206.157l-10.19-9.559c-6.46-3.12-16.43-7.712-17.591-7.651-1.3.08-26.039,9.825-35.438,13.575l-.185-.466c1.387-.551,33.941-13.52,35.593-13.605h.035c1.808,0,16.189,6.925,17.837,7.717l.06.045,9.96,9.339c1.893-1,12.724-6.715,12.909-6.8.065-.03.235-.1,15.133-.1v.5c-5.719,0-14.306,0-14.957.07-.566.285-8.693,4.572-13.02,6.85Z",
    transform: "translate(-138.897 -122.721)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509760",
    "data-name": "Path 509760",
    d: "M266.673,203.011a.871.871,0,1,1-.871-.871A.871.871,0,0,1,266.673,203.011Z",
    transform: "translate(-191.224 -129.556)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509761",
    "data-name": "Path 509761",
    d: "M265.092,203.945a1.582,1.582,0,1,1,1.582-1.582A1.582,1.582,0,0,1,265.092,203.945Zm0-3.035a.6.6,0,1,0,0-.02Z",
    transform: "translate(-190.515 -128.877)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509762",
    "data-name": "Path 509762",
    d: "M312.883,208.191a.871.871,0,1,1-.871-.871A.871.871,0,0,1,312.883,208.191Z",
    transform: "translate(-214.294 -132.142)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509763",
    "data-name": "Path 509763",
    d: "M311.3,209.125a1.582,1.582,0,1,1,1.582-1.582A1.582,1.582,0,0,1,311.3,209.125Zm0-3.035a1.457,1.457,0,1,0,1.452,1.452,1.457,1.457,0,0,0-1.452-1.452Z",
    transform: "translate(-213.585 -131.463)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509764",
    "data-name": "Path 509764",
    d: "M311.546,198.73l.05,1.783-.446-.01.831,1.017.831-1.027h-.461l-.05-1.758Z",
    transform: "translate(-214.299 -127.854)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509765",
    "data-name": "Path 509765",
    d: "M239.844,154.015h.6l.456-.07a6.629,6.629,0,0,0,1.252-.371,6.46,6.46,0,0,0,1.537-.941,6.009,6.009,0,0,0,1.432-1.773,6.129,6.129,0,0,0,.691-2.649c0-2,0-4.331,0-6.94,0-10.446-.025-25.538-.04-44.221v-34.7a6.67,6.67,0,0,0-.17-2.053,3.966,3.966,0,0,0-1.072-1.733,3.881,3.881,0,0,0-1.8-1,9.2,9.2,0,0,0-2.113-.12H135.242a3.505,3.505,0,0,0-3.145,3.465V146.9a11.29,11.29,0,0,0,.105,2.188,5.919,5.919,0,0,0,4.081,4.557,6.564,6.564,0,0,0,2.093.255h41.062l44.221.04,12.018.025H223.659l-44.221.045H138.377a6.9,6.9,0,0,1-2.158-.265,6.139,6.139,0,0,1-4.241-4.727,11.517,11.517,0,0,1-.11-2.233V60.936a3.781,3.781,0,0,1,3.375-3.726c.916-.045,1.788,0,2.684,0H241.7a4.507,4.507,0,0,1,1.092.125,4.171,4.171,0,0,1,1.9,1.042,4.3,4.3,0,0,1,1.132,1.833A7.1,7.1,0,0,1,246,62.328v34.7c0,18.668-.035,33.776-.045,44.221v6.94a6.009,6.009,0,0,1-2.168,4.462,6.4,6.4,0,0,1-1.552.936,6.235,6.235,0,0,1-1.262.361l-.461.065h-.336Z",
    transform: "translate(-124.785 -57.19)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16799",
    "data-name": "Ellipse 16799",
    cx: 5.263,
    cy: 5.263,
    r: 5.263,
    transform: "translate(115.392 53.256) rotate(-76.78)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509766",
    "data-name": "Path 509766",
    d: "M350.308,150.366a10.164,10.164,0,0,0,.21,1.272,5.183,5.183,0,0,0,6.8,3.56,5.145,5.145,0,0,0,2.389-7.867,4.783,4.783,0,0,0-1.087-1.092,4.632,4.632,0,0,0-1.3-.7,5.153,5.153,0,0,0-4.877.716,5.263,5.263,0,0,0-1.923,2.839,10.526,10.526,0,0,0-.21,1.272,3.917,3.917,0,0,1,.115-1.3,5.213,5.213,0,0,1,1.9-2.959,5.343,5.343,0,0,1,5.078-.8,5.008,5.008,0,0,1,1.367.726,5.253,5.253,0,0,1,1.142,1.142,5.358,5.358,0,0,1,0,6.375,5.253,5.253,0,0,1-1.142,1.142,5.142,5.142,0,0,1-1.367.726,5.316,5.316,0,0,1-6.981-3.761A3.916,3.916,0,0,1,350.308,150.366Z",
    transform: "translate(-233.842 -101.027)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509767",
    "data-name": "Path 509767",
    d: "M358.969,155.724a.25.25,0,0,1-.15-.446l1.352-1.057-1.367-1.032a.252.252,0,0,1,.305-.4l1.622,1.232a.251.251,0,0,1,.1.2.255.255,0,0,1-.1.2l-1.612,1.257A.25.25,0,0,1,358.969,155.724Z",
    transform: "translate(-238.041 -104.893)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16800",
    "data-name": "Ellipse 16800",
    cx: 5.263,
    cy: 5.263,
    r: 5.263,
    transform: "translate(0 53.576) rotate(-76.78)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509768",
    "data-name": "Path 509768",
    d: "M130.262,151a10.987,10.987,0,0,0-.215-1.272,5.228,5.228,0,0,0-1.923-2.839,5.1,5.1,0,0,0-2.173-.951,5.163,5.163,0,0,0-2.7.23,4.978,4.978,0,0,0-1.3.7,4.892,4.892,0,0,0-1.082,1.1,5.118,5.118,0,0,0,0,6.069,4.867,4.867,0,0,0,1.082,1.092,4.7,4.7,0,0,0,1.3.7,5.163,5.163,0,0,0,2.7.235,5.1,5.1,0,0,0,2.173-.951,5.263,5.263,0,0,0,1.923-2.839,11.4,11.4,0,0,0,.215-1.272,4.1,4.1,0,0,1-.115,1.3,5.3,5.3,0,0,1-4.156,3.976,5.363,5.363,0,0,1-2.829-.215,5.418,5.418,0,0,1-2.5-1.873,5.338,5.338,0,0,1,0-6.375,5.043,5.043,0,0,1,1.142-1.142,5.112,5.112,0,0,1,1.362-.726,5.418,5.418,0,0,1,2.829-.22,5.343,5.343,0,0,1,2.248,1,5.238,5.238,0,0,1,1.908,2.959A4.1,4.1,0,0,1,130.262,151Z",
    transform: "translate(-118.668 -101.344)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509769",
    "data-name": "Path 509769",
    d: "M130.128,156.353a.235.235,0,0,1-.15-.05l-1.627-1.232a.25.25,0,0,1-.1-.2.245.245,0,0,1,.1-.2l1.607-1.257a.25.25,0,1,1,.305.4l-1.352,1.057,1.367,1.032a.25.25,0,0,1-.15.451Z",
    transform: "translate(-122.986 -105.201)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-9",
    transform: "translate(186.28 178.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509770",
    "data-name": "Path 509770",
    d: "M420.71,408.8c6.675-2.834,14.407-8.408,17.852-15.243A37.987,37.987,0,0,0,420.71,408.8",
    transform: "translate(-383.815 -346.139)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509771",
    "data-name": "Path 509771",
    d: "M423.55,387.628c6.675-2.834,14.4-8.413,17.852-15.248a38.022,38.022,0,0,0-17.852,15.248",
    transform: "translate(-385.233 -335.565)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509772",
    "data-name": "Path 509772",
    d: "M427.4,367.023c6.68-2.834,14.407-8.408,17.857-15.243A38.027,38.027,0,0,0,427.4,367.023",
    transform: "translate(-387.155 -325.28)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509773",
    "data-name": "Path 509773",
    d: "M432.24,343.121c6.3-3.736,13.32-10.336,15.934-17.581a39.259,39.259,0,0,0-15.934,17.581",
    transform: "translate(-389.571 -312.18)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509774",
    "data-name": "Path 509774",
    d: "M437.41,321.534c4.587-6.009,8.868-14.932,8.808-22.674a42.183,42.183,0,0,0-8.808,22.674",
    transform: "translate(-392.152 -298.86)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509775",
    "data-name": "Path 509775",
    d: "M425.434,327.657c-.921-8.122-4.081-18.328-9.434-24.417a49.574,49.574,0,0,0,9.434,24.417",
    transform: "translate(-381.463 -301.047)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509776",
    "data-name": "Path 509776",
    d: "M418.723,345.207c-1.637-8.368-5.769-18.718-11.853-24.587a51.477,51.477,0,0,0,11.853,24.587",
    transform: "translate(-376.905 -309.724)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509777",
    "data-name": "Path 509777",
    d: "M413.768,366.827c-1.632-8.368-5.764-18.718-11.848-24.587a51.518,51.518,0,0,0,11.848,24.587",
    transform: "translate(-374.434 -320.517)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509778",
    "data-name": "Path 509778",
    d: "M409.8,393.372c-1.632-8.368-5.764-18.718-11.848-24.592A51.532,51.532,0,0,0,409.8,393.372",
    transform: "translate(-372.452 -333.768)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509779",
    "data-name": "Path 509779",
    d: "M428.408,341a.292.292,0,0,1-.05.125,3.022,3.022,0,0,0-.13.371l-.461,1.452c-.4,1.257-.946,3.09-1.582,5.363s-1.342,5.008-2.068,8.012-1.437,6.395-2.108,9.935-1.2,6.93-1.642,10.015-.756,5.884-1,8.232-.4,4.251-.476,5.568c-.04.646-.075,1.152-.1,1.5v.4a.35.35,0,0,0,0,.135v-.135c0-.09.03-.23.045-.391.035-.366.085-.871.145-1.5.115-1.317.3-3.215.561-5.558s.6-5.133,1.042-8.222,1-6.47,1.658-10.015,1.387-6.89,2.088-9.93,1.4-5.759,2-8.012,1.127-4.116,1.5-5.383l.416-1.457c.045-.16.075-.285.105-.386a.5.5,0,0,0,.05-.115Z",
    transform: "translate(-382.855 -319.898)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509780",
    "data-name": "Path 509780",
    d: "M413.934,412.126c2.834-5.929,4.892-14.266,3.505-20.776a36.87,36.87,0,0,0-3.505,20.776",
    transform: "translate(-380.294 -345.036)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509781",
    "data-name": "Path 509781",
    d: "M404.533,396.8c2.829-5.934,4.892-14.266,3.505-20.776a36.83,36.83,0,0,0-3.505,20.776",
    transform: "translate(-375.599 -337.382)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509782",
    "data-name": "Path 509782",
    d: "M396.1,381.206c2.829-5.934,4.887-14.266,3.505-20.776a36.83,36.83,0,0,0-3.505,20.776",
    transform: "translate(-371.391 -329.599)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509783",
    "data-name": "Path 509783",
    d: "M387,364.077c2.1-6.274,3.16-14.827,1-21.087a37.055,37.055,0,0,0-1,21.087",
    transform: "translate(-366.448 -320.892)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509784",
    "data-name": "Path 509784",
    d: "M376.359,351.43c-.205-6.68-2.173-15.023-6.319-19.97a36.22,36.22,0,0,0,6.319,19.97",
    transform: "translate(-358.518 -315.136)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509785",
    "data-name": "Path 509785",
    d: "M366.124,368.19c-4.912-4.637-12.379-9.239-19.094-9.84a37.056,37.056,0,0,0,19.094,9.84",
    transform: "translate(-347.03 -328.56)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509786",
    "data-name": "Path 509786",
    d: "M371.086,383.558c-5.508-4.362-13.681-8.453-20.746-8.468a38.558,38.558,0,0,0,20.746,8.468",
    transform: "translate(-348.682 -336.918)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509787",
    "data-name": "Path 509787",
    d: "M379.311,400.443c-5.508-4.362-13.68-8.458-20.751-8.473a38.5,38.5,0,0,0,20.751,8.473",
    transform: "translate(-352.786 -345.345)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509788",
    "data-name": "Path 509788",
    d: "M390.866,419.913c-5.508-4.362-13.681-8.458-20.746-8.473a38.488,38.488,0,0,0,20.746,8.473",
    transform: "translate(-358.558 -355.065)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509789",
    "data-name": "Path 509789",
    d: "M381.38,368.92a.343.343,0,0,0,.03.11l.11.31c.115.3.27.7.461,1.2.4,1.042,1,2.539,1.8,4.372,1.572,3.67,3.9,8.678,6.79,14.046,1.447,2.679,2.9,5.2,4.261,7.461s2.639,4.261,3.751,5.924,2,3,2.674,3.9l.751,1.042.2.27a.536.536,0,0,0,.075.085.171.171,0,0,0-.055-.1l-.18-.285-.716-1.067c-.626-.921-1.5-2.268-2.6-3.941s-2.344-3.69-3.7-5.949-2.789-4.782-4.241-7.461c-2.884-5.358-5.233-10.366-6.845-14-.806-1.823-1.442-3.3-1.873-4.336l-.5-1.182c-.055-.125-.1-.225-.14-.305a.442.442,0,0,0-.05-.1Z",
    transform: "translate(-364.179 -333.837)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509790",
    "data-name": "Path 509790",
    d: "M387.29,434.27h28.127v5.418h-2.889l-2.434,15.463H392.7l-2.5-15.463H387.29Z",
    transform: "translate(-367.13 -366.463)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509791",
    "data-name": "Path 509791",
    d: "M387.29,444.74c0-.075,6.249-.13,13.961-.13s13.966.055,13.966.13-6.254.13-13.966.13S387.29,444.805,387.29,444.74Z",
    transform: "translate(-367.13 -371.626)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-9",
    transform: "translate(25.046 109.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509792",
    "data-name": "Path 509792",
    d: "M164.72,327.418a16.176,16.176,0,0,0,3.4-.18,7.782,7.782,0,0,0,2.268-1s2.469.341,2.864-.21a2.1,2.1,0,0,0,.371-1.182l1.813-.225,1.642.31.906,1.107s.681,0,.711-.411c0,0,.906-.411.821-.7s-.586-1.642-.586-1.642l-.691-1.482s-4.477-.28-4.647-.17-5.839,2.754-5.839,2.754l-2.1.5Z",
    transform: "translate(-94.778 -241.993)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509793",
    "data-name": "Path 509793",
    d: "M167.747,316.748l7.1-1.592,4.957-.265s4.226,1.963,4.106,3.721l.886.476s-.075,1.312-1.132,1a10.465,10.465,0,0,1-1.5-.561l1.137,1.733a1.647,1.647,0,0,1-1.567.03c-.356-.17-2.849-2.058-2.849-2.058l-2.108-.06s-3.916,2.694-5.734,3a17.412,17.412,0,0,1-4.912-.33Z",
    transform: "translate(-95.482 -238.639)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509794",
    "data-name": "Path 509794",
    d: "M194.081,321.093c0-.03.18.03.471,0a.6.6,0,0,0,.4-.3,1.227,1.227,0,0,0,.12-.671l.04.07-3.065-2-.921-.6a7.051,7.051,0,0,0-.836-.5H188.6a10.014,10.014,0,0,1-1.607-.045,9.467,9.467,0,0,1,1.592-.14l.8-.04h.861a.423.423,0,0,1,.11,0,9.013,9.013,0,0,1,.916.541l.926.6c1.182.786,2.248,1.5,3,2.078l.04.03v.045a1.342,1.342,0,0,1-.18.766.686.686,0,0,1-.5.32.86.86,0,0,1-.371-.035A1.125,1.125,0,0,0,194.081,321.093Z",
    transform: "translate(-105.896 -239.624)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509795",
    "data-name": "Path 509795",
    d: "M194.149,323.235a4.974,4.974,0,0,1-.741-.861c-.436-.551-1-1.327-1.657-2.193h.025l-.085-.065c-.215-.165-.431-.326-.641-.466l-.32-.2a.871.871,0,0,0-.31-.1,10.3,10.3,0,0,0-1.242-.125,5.956,5.956,0,0,1-1.167-.09,4.362,4.362,0,0,1,1.172-.1,8.059,8.059,0,0,1,1.282.07,1.272,1.272,0,0,1,.386.12c.115.06.225.13.336.2.225.145.446.305.666.476l.085.07h0c.636.871,1.2,1.662,1.592,2.243a5.009,5.009,0,0,1,.621,1.012Z",
    transform: "translate(-106.406 -240.709)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509796",
    "data-name": "Path 509796",
    d: "M243.069,433.51l.165,13.14s13.35,3.295,13.62,5.719l-25.408,2.188-1.1-20.466Z",
    transform: "translate(-127.544 -297.86)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633177",
    "data-name": "Group 633177",
    transform: "translate(107.074 148.033)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509797",
    "data-name": "Path 509797",
    d: "M239.563,458.274a1.042,1.042,0,0,0-.661,1.222,1,1,0,0,0,1.207.666,1.1,1.1,0,0,0,.691-1.3,1.042,1.042,0,0,0-1.332-.556",
    transform: "translate(-238.873 -458.239)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_633178",
    "data-name": "Group 633178",
    transform: "translate(103.793 153.377)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509798",
    "data-name": "Path 509798",
    d: "M232.43,472.23l-.11-2.063,24.607-1.257a1.753,1.753,0,0,1,1.052,1.307Z",
    transform: "translate(-232.32 -468.91)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_509799",
    "data-name": "Path 509799",
    d: "M254.656,459.353c0,.125-.616.21-1.207.641s-.9.971-1,.926.025-.791.761-1.292S254.682,459.237,254.656,459.353Z",
    transform: "translate(-138.56 -310.713)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509800",
    "data-name": "Path 509800",
    d: "M260.734,461.356c.03.12-.5.355-.891.9s-.5,1.112-.616,1.112-.24-.7.265-1.367S260.724,461.236,260.734,461.356Z",
    transform: "translate(-141.909 -311.74)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509801",
    "data-name": "Path 509801",
    d: "M265.5,465.453c-.11.03-.31-.581-.025-1.277s.851-1,.911-.9-.285.5-.5,1.057S265.624,465.433,265.5,465.453Z",
    transform: "translate(-145.006 -312.712)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509802",
    "data-name": "Path 509802",
    d: "M253.528,453.093c-.05.115-.626-.025-1.327.055s-1.237.331-1.307.225.436-.571,1.262-.656S253.583,452.993,253.528,453.093Z",
    transform: "translate(-137.797 -307.442)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633179",
    "data-name": "Group 633179",
    transform: "translate(102.946 138.254)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509803",
    "data-name": "Path 509803",
    d: "M243.239,438.71l.035,2.339L230.8,442.385l-.17-2.949Z",
    transform: "translate(-230.63 -438.71)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_509804",
    "data-name": "Path 509804",
    d: "M252.069,446.3a2.424,2.424,0,0,1-1.277.055,5.836,5.836,0,0,1-1.352-.345,5.972,5.972,0,0,1-.751-.356,1.5,1.5,0,0,1-.4-.28.541.541,0,0,1-.09-.656.671.671,0,0,1,.531-.31,1.8,1.8,0,0,1,.5.04,4.507,4.507,0,0,1,2,.951c.616.5.841.971.8,1s-.361-.33-1-.751a5.067,5.067,0,0,0-1.167-.586,4.281,4.281,0,0,0-.746-.19c-.27-.06-.5-.05-.566.075,0,.045-.025.065.035.14a1.366,1.366,0,0,0,.3.205,6.909,6.909,0,0,0,.691.351,7.057,7.057,0,0,0,1.257.416A7.868,7.868,0,0,1,252.069,446.3Z",
    transform: "translate(-136.419 -303.298)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509805",
    "data-name": "Path 509805",
    d: "M255.273,444.476a2,2,0,0,1-.4-1.217,4.132,4.132,0,0,1,.11-1.4,4.312,4.312,0,0,1,.285-.791,1.062,1.062,0,0,1,.781-.686.6.6,0,0,1,.551.331,1.781,1.781,0,0,1,.155.461,2.8,2.8,0,0,1,.04.861,2.844,2.844,0,0,1-.5,1.342c-.466.686-.976.861-1,.816a6.408,6.408,0,0,0,.726-.971,2.949,2.949,0,0,0,.346-1.217,2.629,2.629,0,0,0-.06-.736c-.055-.27-.165-.5-.265-.451a1,1,0,0,0-.426.441,4.008,4.008,0,0,0-.28.706,4.472,4.472,0,0,0-.185,1.282C255.183,444,255.338,444.456,255.273,444.476Z",
    transform: "translate(-139.778 -301.289)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509806",
    "data-name": "Path 509806",
    d: "M112.879,335.935s41.362-6.865,43.2-7.151c7.091-1.092,15.183-.225,17.882,4.862a38.117,38.117,0,0,1,2.389,11.748c.34,6.254,2.824,43.3,2.824,43.3l-17.066,2.839-5.618-41h0l-9.634,1.808c.541-.065-25.038,4.507-32.759,5.313-5.964.606-12.839-2.609-14.211-7.927-.9-3.475-2.859-13.15-2.859-13.15Z",
    transform: "translate(-60.984 -245.368)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509807",
    "data-name": "Path 509807",
    d: "M219.921,361.34a22.64,22.64,0,0,0-2.288,2.549,23.714,23.714,0,0,0-1.652,3,3.119,3.119,0,0,1,.275-1,9.774,9.774,0,0,1,1.167-2.163,10.159,10.159,0,0,1,1.657-1.818,3.084,3.084,0,0,1,.841-.571Z",
    transform: "translate(-120.37 -261.829)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509808",
    "data-name": "Path 509808",
    d: "M57.5,183.024a5.829,5.829,0,0,0-.841,3.32c0,1.137.781,3.44,2.794,3.555-.536,3.25,1.547,5.648,5.008,5.653s7.426-5.934,10.636-7.236l9.314-2.464c.816-.19,1.152-1.187,1.137-2a6.781,6.781,0,0,1,.065-2.5c.406-1.077,1.657-1.652,2.083-2.724.5-1.217-.265-2.569-1.132-3.55s-1.918-1.918-2.193-3.195c-.255-1.177.2-2.5-.391-3.555-.721-1.292-2.619-1.457-3.505-2.644-.426-.581-.561-1.332-1-1.913a3.539,3.539,0,0,0-3.315-1.117c-1.217.13-2.384.576-3.6.666-1.673.12-3.4-.421-5.008.065-1.773.531-2.849,2.1-4.006,3.625l-1.5,1.763a6.754,6.754,0,0,1-1,.816,12.018,12.018,0,0,0-1.9,1.217,2.959,2.959,0,0,0,.205,4.266,3.15,3.15,0,0,0-2.123,3.11,2.636,2.636,0,0,0,.811,2.228A2.128,2.128,0,0,0,57.5,183.024Z",
    transform: "translate(-40.827 -162.616)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509809",
    "data-name": "Path 509809",
    d: "M68.728,192.475a42.784,42.784,0,0,1-1.878-7.2,15.048,15.048,0,0,1,.591-7.351c.13-.351,1.252-2.719,1.622-2.684.27.03-.421,2.238-.285,2.469a12.756,12.756,0,0,1,1.437,7.451,33.551,33.551,0,0,1-1.5,7.316",
    transform: "translate(-45.812 -168.918)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509810",
    "data-name": "Path 509810",
    d: "M76.691,210.359c-5.508-.691-6.129-9.514-6.129-9.514l-.25-21.622c-.2-6.224,3.255-11.517,9.484-11.562l.576.03a11.132,11.132,0,0,1,10.516,10.816c.145,5.4.235,11.367.045,14.246-.391,5.964-6.41,6.575-6.41,6.575s-.16,5.353-.14,7.2c.065,6.35-6.169,3.976-7.712,3.841Z",
    transform: "translate(-47.641 -165.134)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509811",
    "data-name": "Path 509811",
    d: "M91.111,228.184a14.442,14.442,0,0,1-7.651-2.714s1.607,4.7,7.6,4.477Z",
    transform: "translate(-54.209 -193.996)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509812",
    "data-name": "Path 509812",
    d: "M106.613,198.276a.851.851,0,0,1-.866.816.816.816,0,0,1-.836-.816.851.851,0,0,1,.866-.816.816.816,0,0,1,.836.816Z",
    transform: "translate(-64.918 -180.012)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509813",
    "data-name": "Path 509813",
    d: "M105.264,193.141c-.115.105-.731-.411-1.652-.456s-1.612.376-1.708.255.075-.245.381-.441a2.3,2.3,0,0,1,1.372-.346,2.263,2.263,0,0,1,1.307.5C105.234,192.886,105.319,193.076,105.264,193.141Z",
    transform: "translate(-63.404 -177.361)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509814",
    "data-name": "Path 509814",
    d: "M89.393,198.276a.851.851,0,0,1-.866.816.816.816,0,0,1-.836-.816.851.851,0,0,1,.866-.816.816.816,0,0,1,.836.816Z",
    transform: "translate(-56.321 -180.012)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509815",
    "data-name": "Path 509815",
    d: "M87.283,192.916c-.115.11-.736-.406-1.652-.451s-1.612.376-1.708.255.07-.245.376-.441a2.313,2.313,0,0,1,1.377-.346,2.263,2.263,0,0,1,1.307.5C87.248,192.666,87.333,192.871,87.283,192.916Z",
    transform: "translate(-54.427 -177.251)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509816",
    "data-name": "Path 509816",
    d: "M96.438,200.691a6.185,6.185,0,0,1,1.5-.185c.235,0,.456-.05.5-.205a1.192,1.192,0,0,0-.12-.706c-.19-.576-.386-1.182-.6-1.818a30.845,30.845,0,0,1-1.307-4.747,30.517,30.517,0,0,1,1.688,4.632c.2.636.386,1.247.566,1.828a1.342,1.342,0,0,1,.07.926.581.581,0,0,1-.4.32,1.5,1.5,0,0,1-.4.035A5.814,5.814,0,0,1,96.438,200.691Z",
    transform: "translate(-60.672 -177.8)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509817",
    "data-name": "Path 509817",
    d: "M90.825,209.31c.15,0,.1,1,.911,1.748s1.883.7,1.883.841c0,.06-.245.18-.7.165a2.459,2.459,0,0,1-1.572-.641,2.158,2.158,0,0,1-.7-1.462C90.639,209.54,90.765,209.3,90.825,209.31Z",
    transform: "translate(-57.798 -185.928)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509818",
    "data-name": "Path 509818",
    d: "M86.806,185.68c-.1.24-1,.075-2.093.145s-1.973.32-2.1.09c-.055-.11.105-.336.471-.561a3.645,3.645,0,0,1,3.2-.18C86.64,185.355,86.806,185.56,86.806,185.68Z",
    transform: "translate(-53.779 -173.736)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509819",
    "data-name": "Path 509819",
    d: "M105.1,186.956c-.175.2-.8-.05-1.552-.105s-1.412.065-1.547-.16c-.06-.11.05-.31.346-.5a2.138,2.138,0,0,1,1.277-.27,2.113,2.113,0,0,1,1.217.5C105.1,186.635,105.179,186.855,105.1,186.956Z",
    transform: "translate(-63.459 -174.244)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509820",
    "data-name": "Path 509820",
    d: "M66.7,199.356c-.1-.05-4.036-1.432-4.126,2.654s4.036,3.335,4.046,3.215S66.7,199.356,66.7,199.356Z",
    transform: "translate(-43.783 -180.826)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509821",
    "data-name": "Path 509821",
    d: "M66.443,204.966a1.551,1.551,0,0,1-.2.1.731.731,0,0,1-.531,0,1.765,1.765,0,0,1-.781-1.6,2.418,2.418,0,0,1,.22-1,.816.816,0,0,1,.551-.536.361.361,0,0,1,.416.205c.05.115,0,.2.045.2s.09-.065.06-.235a.456.456,0,0,0-.155-.26.536.536,0,0,0-.391-.11,1,1,0,0,0-.761.616,2.5,2.5,0,0,0-.27,1.137,1.843,1.843,0,0,0,1,1.788.756.756,0,0,0,.651-.1C66.433,205.062,66.458,204.971,66.443,204.966Z",
    transform: "translate(-44.818 -182.14)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509822",
    "data-name": "Path 509822",
    d: "M86.69,170.962c.666-.356-1.292-2.5-2.909-3.285-2.444-1.142-6.184-1.878-8.458-1.267a9.9,9.9,0,0,0-6.425,4.532,16.119,16.119,0,0,0-1.908,8.172,4.942,4.942,0,0,0,.546,2.5c.561.911,1.647,1.5,1.582,2.739a1.733,1.733,0,0,0,.411,1.252c.736.806,1.662.07,2.093-.671a11.869,11.869,0,0,0,1.147-5.338,12.058,12.058,0,0,0-.21-3.891c-.19-.681-.5-1.332-.656-2a2.459,2.459,0,0,1,.315-2.038,2.629,2.629,0,0,1,.336-.331,4.266,4.266,0,0,1,4.241-.751c2.293.841,6.209,2.108,7.246,1.342a6.114,6.114,0,0,0,1.853-1.833Z",
    transform: "translate(-45.982 -164.4)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509823",
    "data-name": "Path 509823",
    d: "M78.284,165.056a9.014,9.014,0,0,1,6.9.466,4.687,4.687,0,0,1,2.429,2.749,2.674,2.674,0,0,1-1.382,3.155l-.08.05a6.23,6.23,0,0,1-4.612-.305c-1.457-.526-2.749-1.447-4.206-1.963A8.3,8.3,0,0,0,72.47,169a13.56,13.56,0,0,1,5.814-3.946Z",
    transform: "translate(-48.722 -163.596)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509824",
    "data-name": "Path 509824",
    d: "M68.55,171.566c.035.03.366-.361,1.032-.821a5.909,5.909,0,0,1,1.237-.661,3.766,3.766,0,0,1,1.662-.28,5.508,5.508,0,0,1,2.849,1.177c.636.5.926.921.966.891s-.045-.125-.18-.315a4.346,4.346,0,0,0-.661-.726,5.3,5.3,0,0,0-2.949-1.3,3.836,3.836,0,0,0-1.778.315,5.278,5.278,0,0,0-1.262.741A3.23,3.23,0,0,0,68.55,171.566Z",
    transform: "translate(-46.765 -166.065)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509825",
    "data-name": "Path 509825",
    d: "M93.43,164.79a10.969,10.969,0,0,0,1.082.406,8.938,8.938,0,0,1,4.2,3.455c.381.6.566,1,.606,1a3.14,3.14,0,0,0-.441-1.087,7.712,7.712,0,0,0-4.3-3.535A3.185,3.185,0,0,0,93.43,164.79Z",
    transform: "translate(-59.187 -163.701)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509826",
    "data-name": "Path 509826",
    d: "M68.541,224l-.721,3.11L84.58,237.52l-.751-5.188a25.743,25.743,0,0,0-5.113-4.061A49.033,49.033,0,0,0,68.541,224Z",
    transform: "translate(-46.401 -193.262)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509827",
    "data-name": "Path 509827",
    d: "M61.022,229.569s-5.158,10.931-5.508,15.083,1.042,17.967,1.042,17.967l23.265,26.54,23.22,1.542s-10.991-23.115-13.45-27.621-10.726-24.932-10.726-24.932a12.854,12.854,0,0,0-2.914-4.507c-3.15-3.34-9.259-5.4-14.757-6.51Z",
    transform: "translate(-40.229 -194.825)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509828",
    "data-name": "Path 509828",
    d: "M75.323,241.266c3.45.406,7.882,3,9.419,9.069l1.5,7.511,7.436,15.093,24.362,6.95-3.165,9.544s-24.161-1.918-27.291-2.759S71.467,267.41,71.467,267.41s-6.51-11.222-4.832-19.489A8.015,8.015,0,0,1,75.323,241.266Z",
    transform: "translate(-45.671 -201.855)",
    fill: "#356f92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509829",
    "data-name": "Path 509829",
    d: "M75.257,241.238h-.581a8.654,8.654,0,0,0-1.7.125,7.827,7.827,0,0,0-2.554,1,8.117,8.117,0,0,0-2.619,2.624,8.838,8.838,0,0,0-.921,2,5.227,5.227,0,0,0-.155.566,3.863,3.863,0,0,0-.12.591c-.055.406-.11.816-.17,1.237a21.462,21.462,0,0,0,.356,5.508,35.553,35.553,0,0,0,1.748,6.074,48.311,48.311,0,0,0,2.954,6.4h0c1.883,2.649,3.931,5.443,6.134,8.333a110.175,110.175,0,0,0,7.266,8.753,12.134,12.134,0,0,0,2.248,1.893,4.266,4.266,0,0,0,1.407.386c.5.075,1,.16,1.5.215,2,.265,4.091.476,6.189.686,4.186.411,8.513.791,12.889,1.162l5.679.461-.13.09q1.607-4.867,3.16-9.544l.09.165L93.575,273h-.05v-.045l-7.416-15.108h0q-.5-2.474-.916-4.692a30,30,0,0,0-.951-4.126,11.958,11.958,0,0,0-3.771-5.478,10.686,10.686,0,0,0-3.771-1.973,10.159,10.159,0,0,0-1.072-.245l-.371-.07a2.33,2.33,0,0,1,.376.045,8.2,8.2,0,0,1,1.082.22,10.551,10.551,0,0,1,3.776,1.933,12.053,12.053,0,0,1,3.841,5.508,29.4,29.4,0,0,1,1,4.141q.446,2.213.936,4.687h0l7.456,15.083-.07-.055,24.367,6.935.125.035-.04.125q-1.547,4.672-3.16,9.549l-.035.1h-.1l-5.679-.461c-4.4-.376-8.7-.751-12.894-1.167-2.1-.21-4.166-.426-6.194-.691-.5-.055-1-.14-1.5-.215-.25-.035-.5-.1-.751-.145a2.038,2.038,0,0,1-.741-.27,12.519,12.519,0,0,1-2.283-1.968,109.192,109.192,0,0,1-7.276-8.783c-2.2-2.894-4.241-5.694-6.124-8.353h0a48.572,48.572,0,0,1-2.949-6.435,35.827,35.827,0,0,1-1.8-6.174,21.477,21.477,0,0,1-.336-5.543c.06-.426.12-.846.175-1.252a3.945,3.945,0,0,1,.13-.6,5.108,5.108,0,0,1,.16-.576,8.868,8.868,0,0,1,.946-2.038,8.117,8.117,0,0,1,2.669-2.634,7.8,7.8,0,0,1,2.589-1,7.666,7.666,0,0,1,1.713-.1C75.062,241.213,75.257,241.238,75.257,241.238Z",
    transform: "translate(-45.606 -201.827)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509830",
    "data-name": "Path 509830",
    d: "M112.52,310.394a3.5,3.5,0,0,1,.381-1,14.111,14.111,0,0,1,1.332-2.223,14.267,14.267,0,0,1,1.718-1.943,3.506,3.506,0,0,1,.841-.666c.055.06-1.172,1.147-2.349,2.764S112.6,310.429,112.52,310.394Z",
    transform: "translate(-68.717 -233.481)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509831",
    "data-name": "Path 509831",
    d: "M85.468,242.536a5.254,5.254,0,0,1-.591-.621c-.18-.21-.4-.461-.676-.736s-.571-.606-.941-.936a27.364,27.364,0,0,0-2.634-2.213,31.475,31.475,0,0,0-3.565-2.248,39.289,39.289,0,0,0-7.116-2.869c-.941-.28-1.713-.5-2.243-.626a4.944,4.944,0,0,1-.821-.245,5.784,5.784,0,0,1,.846.145c.541.105,1.317.29,2.268.546a35.413,35.413,0,0,1,7.186,2.794,28.922,28.922,0,0,1,3.585,2.283,24.693,24.693,0,0,1,2.619,2.278c.361.335.651.681.916.966a7.326,7.326,0,0,1,.651.771A5.509,5.509,0,0,1,85.468,242.536Z",
    transform: "translate(-45.932 -197.276)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509832",
    "data-name": "Path 509832",
    d: "M207.324,266.455a.841.841,0,0,0-1.047.566L197.8,295.353l-28.383,4.407a1.683,1.683,0,0,0-1.4,1.918l31.092-4.847h0L207.88,267.5a.841.841,0,0,0-.556-1.042Z",
    transform: "translate(-96.416 -214.44)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509833",
    "data-name": "Path 509833",
    d: "M207.218,266.436a.8.8,0,0,1,.476.336.871.871,0,0,1,.115.706l-.275.956-1.828,6.229-6.585,22.183v.08h-.115l.09-.08h0l-.035.11-.105-.035H199l-30.486,4.822-.581.09h-.125v-.13a1.813,1.813,0,0,1,1-1.908,1.908,1.908,0,0,1,.546-.165l.526-.08,1.047-.165,4.151-.646,8.012-1.247,14.592-2.258-.09.08c2.674-8.878,4.9-16.269,6.46-21.452l1.828-6.009q.155-.5.285-.916a.861.861,0,0,1,.5-.5.771.771,0,0,1,.566,0,.926.926,0,0,0-.551.045.816.816,0,0,0-.451.476q-.12.4-.27.916l-1.768,6.009c-1.537,5.188-3.736,12.589-6.37,21.477v.065h-.07l-14.642,2.313L175.1,298.99l-4.151.646-1.047.165a3.811,3.811,0,0,0-1,.225,1.557,1.557,0,0,0-.861,1.633l-.15-.105.581-.09,30.516-4.727h.025l-.14.075h0v-.07h.07l-.1.13v-.045h0c2.754-9.159,5.058-16.8,6.67-22.163.811-2.669,1.452-4.767,1.893-6.209l.29-.951a.841.841,0,0,0-.1-.671A.961.961,0,0,0,207.218,266.436Z",
    transform: "translate(-96.31 -214.421)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509834",
    "data-name": "Path 509834",
    d: "M228.791,325.625c-.06.04-.361-.31-.731-.731s-.666-.776-.616-.831.436.22.816.661S228.852,325.585,228.791,325.625Z",
    transform: "translate(-126.091 -243.215)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509835",
    "data-name": "Path 509835",
    d: "M220.459,326.277c0-.03.125-.125.325,0a.376.376,0,0,1,.2.351.426.426,0,0,1-.781.215.381.381,0,0,1-.035-.4c.12-.21.3-.175.29-.145a.528.528,0,0,0-.12.215.22.22,0,0,0,.26.25.205.205,0,0,0,.145-.16.18.18,0,0,0-.065-.17C220.565,326.307,220.474,326.307,220.459,326.277Z",
    transform: "translate(-122.44 -244.292)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509836",
    "data-name": "Path 509836",
    d: "M224.079,325.717c0-.03.125-.125.325,0a.371.371,0,0,1,.2.351.431.431,0,0,1-.315.386.446.446,0,0,1-.466-.17.381.381,0,0,1-.035-.4c.125-.21.3-.18.29-.15a.57.57,0,0,0-.12.215.205.205,0,0,0,.055.185.22.22,0,0,0,.205.07.215.215,0,0,0,.145-.16.18.18,0,0,0-.065-.175C224.195,325.752,224.094,325.752,224.079,325.717Z",
    transform: "translate(-124.248 -244.013)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509837",
    "data-name": "Path 509837",
    d: "M73.082,399.906,61.56,437.757l4.2.04L81.33,399.51Z",
    transform: "translate(-43.276 -280.885)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509838",
    "data-name": "Path 509838",
    d: "M183.52,389.141c-.03,0,13.02,42.944,13.02,42.944l4.166.06-8.032-43.866Z",
    transform: "translate(-104.164 -275.279)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509839",
    "data-name": "Path 509839",
    d: "M36.846,279.034a4.447,4.447,0,0,0-4.752-.826c-3.23,1.377-7.957,4.2-6.9,8.663,1.327,5.578,16.6,41.963,21.527,53.65a5.844,5.844,0,0,0,5.428,3.57l64.006-.541a4.732,4.732,0,0,0,4.647-5.343l-2.394-18.177a12.954,12.954,0,0,0-11.7-11.212l-41.392-3.676Z",
    transform: "translate(-25.046 -220.149)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509840",
    "data-name": "Path 509840",
    d: "M59.87,362.179a.616.616,0,0,1-.035-.135,2.307,2.307,0,0,0-.08-.386q-.105-.541-.285-1.5c-.235-1.322-.576-3.195-1-5.508s-.9-5.1-1.442-8.177c-.265-1.537-.551-3.155-.841-4.827-.145-.841-.3-1.693-.446-2.559a6.87,6.87,0,0,1-.07-2.7,3.12,3.12,0,0,1,.616-1.242,3.585,3.585,0,0,1,1.1-.861,7.827,7.827,0,0,1,2.5-.716c1.7-.19,3.335-.285,4.9-.4,3.12-.215,5.929-.356,8.292-.451s4.276-.135,5.6-.155h2.033a.574.574,0,0,1-.135,0h-.4l-1.5.06-5.588.24c-2.364.115-5.173.275-8.287.5-1.552.12-3.2.225-4.877.416a7.465,7.465,0,0,0-2.439.691,2.934,2.934,0,0,0-1.567,1.923,6.59,6.59,0,0,0,.075,2.6q.22,1.3.436,2.554.436,2.5.826,4.832c.5,3.08,1,5.849,1.387,8.187s.7,4.2.911,5.508c.1.636.18,1.142.235,1.5a2.347,2.347,0,0,0,.055.4A.541.541,0,0,1,59.87,362.179Z",
    transform: "translate(-40.284 -247.46)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509841",
    "data-name": "Path 509841",
    d: "M136.851,388.15c0,.07-16.525.13-36.92.13S63,388.22,63,388.15s16.525-.13,36.925-.13S136.851,388.08,136.851,388.15Z",
    transform: "translate(-43.995 -275.149)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509842",
    "data-name": "Path 509842",
    d: "M56.538,307.454c-.055.05-5.108-5.764-11.287-12.979S34.1,281.37,34.16,281.32s5.108,5.764,11.287,12.984S56.613,307.409,56.538,307.454Z",
    transform: "translate(-29.596 -221.879)",
    fill: "#263238"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyOngoing);
export default __webpack_public_path__ + "static/media/EmptyOngoing.1d6c48a3fe253420bfc6c3fd69c62cb7.svg";
export { ForwardRef as ReactComponent };